module.exports = __webpack_public_path__ + "media/images/admin/icons/shopping-bag-1d26564602e1b9bb7b8e1a9beecb2ae0.svg";